const __WEBPACK_NAMESPACE_OBJECT__ = require("core-js/modules/esnext.promise.all-settled.js");